import $ from 'jquery';

export default {
    init(params) {
        const elements = {
            call: '.js-Comment-Action-Call',
            holder: '.js-Comment-Holder',
            box: '.js-Comment-Action-Box',
        };

        params.$document
            .on('mouseenter', elements.call, function () {
                const $this = $(this);
                const commentActions = $this.find(elements.box);

                commentActions.addClass('fn-active');
            })
            .on('mouseleave', elements.call, function () {
                const $this = $(this);
                const moderationBox = $this.find('.js-BubbleBox-Call');
                const commentActions = $this.find(elements.box);

                if (!moderationBox.hasClass('fn-active')) {
                    commentActions.removeClass('fn-active');
                }
            });
    },
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/ui-actions.js